import React from 'react';
/*eslint-disable*/
export const LocationIcon = ({width, height}) => <svg viewBox='0 0 10 14' width={width || 10} height={height || 14} fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M0 4.9C0 2.191 2.191 0 4.9 0c2.709 0 4.9 2.191 4.9 4.9 0 3.675-4.9 9.1-4.9 9.1S0 8.575 0 4.9zm4.9-3.5a3.501 3.501 0 00-3.5 3.5c0 1.995 2.044 5.047 3.5 6.916 1.484-1.883 3.5-4.9 3.5-6.916 0-1.932-1.568-3.5-3.5-3.5zm1.75 3.5a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z" fill="#919191"/>
</svg>
